<button type="icon" mat-icon-button [matMenuTriggerFor]="menu" #menuTrigger="matMenuTrigger"
	[color]="helpText.modifiedBy ? 'primary' : ''" [disabled]="disabled" (click)="openMenu()">
	<mat-icon>info</mat-icon>
</button>

<mat-menu class="padding-horizontal-sm" #menu="matMenu">
	<div (click)="$event.stopPropagation()" class="overflow-hidden">
		<preview-help-text [helpText]="helpText"></preview-help-text>
	</div>
</mat-menu>